<template>
  <div v-if="block.data.items !== undefined || block.data.file.url" class="entry-gallery">
    <div v-if="block.data.items !== undefined" class="entry-gallery__list">
      <div
        v-for="(image, index) in block.data.items"
        class="entry-gallery__col"
        :class="{ 'entry-gallery__col--half': block.data.items.length > 1 }"
        :key="index"
      >
        <img :alt="article.title" :src="image.file.url" />
      </div>
    </div>
    <video v-else ref="player" playsinline controls>
      <source :src="block.data.file.url" type="video/mp4" />
    </video>
    <!-- <player v-else :options="{ autoplay: false, volume: 0.5 }" :sources="[{ src: block.data.file.url }]"> </player> -->
  </div>
</template>
<script>
// import player from "vue-video";
import Plyr from "plyr";

export default {
  name: "ImageBlock",
  props: ["block", "article"],
  // components: { player },
  mounted() {
    new Plyr(this.$refs.player);
  },
};
</script>
<style lang="scss" scoped>
</style>
